import styled, { css } from 'styled-components';
export const Container = styled.div `
  cursor: pointer;
  height: 100%;
  display: flex;
  gap: var(--space-300);
  align-items: center;
  padding: var(--space-100) var(--space-300);
`;
export const Icon = styled.div `
  color: var(--icon-secondary);
`;
export const Content = styled.div `
  ${({ minWidth }) => minWidth &&
    css `
      min-width: calc(${minWidth}px - var(--space-200));
    `}
`;
